import { AttributeSelectedColorfulOption } from '@/fo/api/magento';

import { ProductGroupName } from '../types';

export const getProductGroupName = (
  productGroup: AttributeSelectedColorfulOption
): ProductGroupName => {
  switch (productGroup.value) {
    case '4':
      return 'gift';
    case '5':
      return 'sample';
    case '6':
      return 'product';
    default:
      return 'product';
  }
};
